import { render } from "./GeneralFilterableIndex.vue?vue&type=template&id=b4885806&ts=true"
import script from "./GeneralFilterableIndex.vue?vue&type=script&lang=ts"
export * from "./GeneralFilterableIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__